module.exports = {"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cloudhsmv2-2017-04-28.paginators.json
// module id = 655
// module chunks = 1